// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ErrorViewCmp from "../ErrorViewCmp.bs.js";
import * as Row$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as FormInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as SendSMSAssetsManager from "../../assets/SendSMSAssetsManager.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

function SelectTemplateCmp$SmsTemplateCmp(Props) {
  var template_id = Props.template_id;
  var template_title = Props.template_title;
  var template_message = Props.template_message;
  var on_select_template = Props.on_select_template;
  var is_selected = Props.is_selected;
  var searchIcon = SendSMSAssetsManager.getImage("message_quote.svg");
  return React.createElement(Row$Catalyst.make, {
              children: null,
              className: "w-full p-8px cursor-pointer " + (
                is_selected ? "selected-template" : ""
              ),
              on_click: on_select_template
            }, React.createElement("div", {
                  className: "template-icon mr-10"
                }, React.createElement("img", {
                      src: searchIcon
                    })), React.createElement("div", {
                  className: "template-body w-90"
                }, React.createElement("div", {
                      className: "title"
                    }, template_title), React.createElement("div", {
                      className: "subtitle"
                    }, String(template_id)), React.createElement("div", {
                      className: "message-body"
                    }, template_message)));
}

var SmsTemplateCmp = {
  make: SelectTemplateCmp$SmsTemplateCmp
};

function filteredTemplates(template_list, search_value) {
  return React.useMemo((function () {
                if (typeof template_list === "number" || template_list.TAG !== /* Live */1) {
                  return /* [] */0;
                } else {
                  return List.filter(function (template) {
                                if (search_value === "") {
                                  return true;
                                }
                                var lowerCaseSearchValue = search_value.trim().toLowerCase();
                                var lowerCaseTemplateTitle = template.template_title.trim().toLowerCase();
                                if (lowerCaseTemplateTitle.includes(lowerCaseSearchValue)) {
                                  return true;
                                } else {
                                  return String(template.template_id) === search_value;
                                }
                              })(template_list._0);
                }
              }), [
              search_value,
              template_list
            ]);
}

var FilterTemplates = {
  filteredTemplates: filteredTemplates
};

function SelectTemplateCmp(Props) {
  var template_list = Props.template_list;
  var on_select_template = Props.on_select_template;
  var selected_template = Props.selected_template;
  var searchIcon = SendSMSAssetsManager.getImage("search.svg");
  var match = React.useState(function () {
        return "";
      });
  var setSearchValue = match[1];
  var searchValue = match[0];
  var filteredTemplates$1 = filteredTemplates(template_list, searchValue);
  var tmp;
  if (typeof template_list === "number") {
    tmp = React.createElement(CircularLoader$Catalyst.make, {});
  } else {
    switch (template_list.TAG | 0) {
      case /* Loading */0 :
          tmp = React.createElement(CircularLoader$Catalyst.make, {});
          break;
      case /* Live */1 :
          tmp = List.length(filteredTemplates$1) === 0 ? React.createElement(ErrorViewCmp.make, {
                  message: "No Template ID found"
                }) : React.createElement(React.Fragment, undefined, React.createElement("div", {
                      className: "recent-messages"
                    }, "Recent Messages"), React.createElement("div", {
                      className: "mt-2"
                    }, $$Array.of_list(List.map((function (template) {
                                return React.createElement(SelectTemplateCmp$SmsTemplateCmp, {
                                            template_id: template.template_id,
                                            template_title: template.template_title,
                                            template_message: template.template_message,
                                            on_select_template: (function (param) {
                                                return Curry._1(on_select_template, template);
                                              }),
                                            is_selected: selected_template !== undefined ? selected_template.template_id === template.template_id : false,
                                            key: String(template.template_id)
                                          });
                              }), filteredTemplates$1))));
          break;
      case /* Error */2 :
          tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                error: template_list._0
              });
          break;
      
    }
  }
  return React.createElement("div", {
              className: "mt-2 p-1"
            }, React.createElement("div", {
                  className: "heading"
                }, "Message"), React.createElement(FormTextInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                          return Curry._1(setSearchValue, (function (param) {
                                        return FormHelper$Catalyst.TargetEventWrapper.value($$event);
                                      }));
                        }), undefined, undefined, "Search via template ID or Title", undefined, undefined, undefined, undefined, undefined, "search-input", undefined, undefined, {
                        className: "",
                        startAdornment: React.createElement("div", {
                              className: "search-image"
                            }, React.createElement("img", {
                                  src: searchIcon
                                })),
                        accept: undefined
                      }, undefined, undefined, undefined, undefined),
                  textinput_props: {
                    value: searchValue
                  }
                }), tmp);
}

var make = SelectTemplateCmp;

export {
  SmsTemplateCmp ,
  FilterTemplates ,
  make ,
  
}
/* react Not a pure module */
